import { useState } from 'react';
import { OnboardingShell } from '../OnboardingShell';
import { saveBankroll } from '../../../utils/api/saveBankroll';

const QUICK_PICKS = [
	{ label: '$100', value: 100 },
	{ label: '$500', value: 500 },
	{ label: '$1k', value: 1000 },
	{ label: '$5k', value: 5000 },
	{ label: '$10k', value: 10000 },
	{ label: '$25k', value: 25000 },
];

const formatPreview = (n) => {
	if (!n && n !== 0) return '';
	const num = Number(n);
	if (Number.isNaN(num)) return '';
	return num.toLocaleString('en-US');
};

export const BankrollStep = (props) => {
	const { stepIndex, totalSteps, onBack, onNext, bankroll, setBankroll } = props;

	const [pick, setPick] = useState(null);
	const [custom, setCustom] = useState('');
	const [submitting, setSubmitting] = useState(false);

	const value = custom !== '' ? Number(custom) : pick;
	const hasValue = value !== null && value !== undefined && !Number.isNaN(value) && Number(value) > 0;

	const handleQuickPick = (v) => {
		setPick(v);
		setCustom('');
	};

	const handleCustomChange = (e) => {
		setCustom(e.target.value);
		setPick(null);
	};

	const handleContinue = async () => {
		if (!hasValue || submitting) return;
		setSubmitting(true);
		try {
			const userdb = JSON.parse(window.localStorage.getItem('userdb'));
			await saveBankroll(value, userdb.email);
			if (setBankroll) setBankroll(value);
		} catch (e) {
			console.error('saveBankroll failed', e);
		} finally {
			setSubmitting(false);
			onNext();
		}
	};

	return (
		<OnboardingShell
			stepIndex={stepIndex}
			totalSteps={totalSteps}
			title="What's your bankroll?"
			subtitle="We use this to recommend optimal bet sizes. You can update it anytime in settings."
			onBack={onBack}
			canContinue={hasValue && !submitting}
			onContinue={handleContinue}
			continueLabel={submitting ? 'Saving...' : 'Continue'}
			onSkip={onNext}
			skipLabel="Skip for now">
			<div className="grid grid-cols-3 gap-2.5 mb-5">
				{QUICK_PICKS.map((q) => (
					<div
						key={q.value}
						onClick={() => handleQuickPick(q.value)}
						className={`ob-chip ${pick === q.value ? 'ob-chip-selected' : ''}`}>
						{q.label}
					</div>
				))}
			</div>

			<div>
				<div className="text-xs text-[#8a90a2] mb-1.5 ml-0.5">Or enter a custom amount</div>
				<div
					className="ob-input flex items-center"
					style={{ paddingTop: 0, paddingBottom: 0 }}>
					<span className="text-[#8a90a2] pr-1.5">$</span>
					<input
						type="number"
						min="0"
						placeholder="0"
						value={custom}
						onChange={handleCustomChange}
						style={{
							border: 'none',
							outline: 'none',
							background: 'transparent',
							color: '#ffffff',
							fontSize: 16,
							flex: 1,
							padding: '12px 0',
						}}
					/>
				</div>
				{hasValue && (
					<div className="mt-2 text-xs text-[#8a90a2]">
						Bankroll set to <span className="text-white font-semibold">${formatPreview(value)}</span>
					</div>
				)}
			</div>
		</OnboardingShell>
	);
};
